import { Box, Container, Typography, Button } from '@mui/material';
import { FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';
import { motion } from 'framer-motion';
import profile from '../data/profile';
import { trackContactClick } from '../utils/analytics';

function ContactSection() {
  const { links } = profile;

  return (
    <Box id="contact" component="section" sx={{ py: { xs: 4, sm: 5.5, md: 7 }, background: 'transparent' }}>
      <Container maxWidth="lg">
        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 2, md: 2.5 } }}>
              <Box sx={{ width: 3, height: 22, backgroundColor: '#C4785D', borderRadius: 2, flexShrink: 0 }} />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                <FaEnvelope size={17} color="#877D72" />
                <Typography variant="h5" component="h2" sx={{ fontSize: { xs: '1.3rem', md: '1.4rem' }, color: '#EAE3D6', fontWeight: 600, letterSpacing: '-0.015em' }}>
                  Let's Connect
                </Typography>
              </Box>
            </Box>

            <Typography sx={{ mb: 3.5, color: '#877D72', fontSize: { xs: '0.97rem', md: '1.05rem' }, maxWidth: 440, lineHeight: 1.75 }}>
              Email would be best — please feel free to reach out!
            </Typography>

            <Box sx={{ display: 'flex', gap: { xs: 1.25, md: 1.5 }, flexWrap: 'wrap', justifyContent: 'center' }}>
              {links.email && (
                <Button
                  variant="contained"
                  href={`mailto:${links.email}`}
                  startIcon={<FaEnvelope size={15} />}
                  onClick={() => trackContactClick('Email')}
                  sx={{
                    backgroundColor: '#C4785D',
                    color: '#EAE3D6',
                    fontWeight: 600,
                    fontSize: { xs: '0.95rem', md: '1rem' },
                    px: { xs: 2.75, md: 3.25 },
                    py: 1.25,
                    '&:hover': { backgroundColor: '#A65D42' },
                  }}
                >
                  Email Me
                </Button>
              )}
              {links.linkedin && (
                <Button
                  variant="outlined"
                  href={links.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<FaLinkedin size={15} />}
                  onClick={() => trackContactClick('LinkedIn')}
                  sx={{
                    borderColor: 'rgba(234,227,214,0.15)',
                    color: '#877D72',
                    fontSize: { xs: '0.95rem', md: '1rem' },
                    px: { xs: 2.75, md: 3.25 },
                    py: 1.25,
                    '&:hover': { borderColor: '#C4785D', color: '#C4785D', backgroundColor: 'rgba(196,120,93,0.07)' },
                  }}
                >
                  LinkedIn
                </Button>
              )}
              {links.github && (
                <Button
                  variant="outlined"
                  href={links.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<FaGithub size={15} />}
                  onClick={() => trackContactClick('GitHub')}
                  sx={{
                    borderColor: 'rgba(234,227,214,0.15)',
                    color: '#877D72',
                    fontSize: { xs: '0.95rem', md: '1rem' },
                    px: { xs: 2.75, md: 3.25 },
                    py: 1.25,
                    '&:hover': { borderColor: '#C4785D', color: '#C4785D', backgroundColor: 'rgba(196,120,93,0.07)' },
                  }}
                >
                  GitHub
                </Button>
              )}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}

export default ContactSection;
